export default __webpack_public_path__ + "static/media/yellowbg.edfc5c49.svg";